{
  "$vuetify": {
    "badge": "Badge",
    "noDataText": "Geen gegevens gevonden",
    "close": "Sluiten",
    "open": "Openen",
    "loading": "Laden",
    "dataIterator": {
      "loadingText": "Laden..."
    },
    "carousel": {
      "ariaLabel": {
        "delimiter": "dia"
      }
    },
    "dataFooter": {
      "itemsPerPageText": "Items per pagina:",
      "itemsPerPageAll": "Alle",
      "pageText": "{0}-{1} van {2}",
      "firstPage": "Eerste Pagina",
      "prevPage": "Vorige Pagina",
      "nextPage": "Volgende Pagina",
      "lastPage": "Laatste Pagina"
    },
    "pagination": {
      "showing": "Toont {0} tot {1} van {2} resultaten",
      "ariaLabel": {
        "root": "paginering",
        "previous": "vorige",
        "first": "eerste",
        "last": "laatste",
        "next": "volgende",
        "currentPage": "huidige pagina",
        "page": "pagina"
      }
    },
    "input": {
      "clear": "wissen",
      "appendAction": "toegevoegde actie",
      "prependAction": "voorafgaande actie",
      "counterSize": "telgrootte",
      "otp": "eenmalig wachtwoord"
    },
    "fileInput": {
      "counterSize": "telgrootte"
    },
    "rating": {
      "ariaLabel": {
        "item": "item"
      }
    },
    "datePicker": {
      "header": "Selecteer Datum",
      "items": [
        "januari",
        "februari",
        "maart",
        "april",
        "mei",
        "juni",
        "juli",
        "augustus",
        "september",
        "oktober",
        "november",
        "december"
      ],
      "weekdays": [
        "zondag",
        "maandag",
        "dinsdag",
        "woensdag",
        "donderdag",
        "vrijdag",
        "zaterdag"
      ],
      "weekdaysShort": [
        "zon",
        "maa",
        "din",
        "woe",
        "don",
        "vri",
        "zat"
      ]
    },
    "colorPicker": {
      "ariaLabel": {
        "eyedropper": "Pipet",
        "hexInput": "HEX waardes",
        "hueSlider": "Tint schuifregelaar"
      }
    }
  },
  "Validation": {
    "required": "Dit veld is verplicht",
    "email": "Het e-mailveld moet een geldig e-mailadres zijn",
    "password": "Veld moet minimaal één hoofdletter, kleine letter, speciaal teken en cijfer bevatten met min 8 tekens",
    "confirmed": "Wachtwoordbevestiging komt niet overeen",
    "phone": "Ongeldig telefoonnummerformaat",
    "regex": "Het formaat van het Regex-veld is ongeldig",
    "alpha": "Het Alpha-veld mag alleen alfabetische tekens bevatten",
    "url": "URL is ongeldig",
    "length": "De lengte van het veld moet {length} tekens zijn.",
    "alphaDash": "Alle tekens zijn niet geldig",
    "time": "Ongeldig tijdformaat",
    "lengthMax": "Voer maximaal {length} tekens in",
    "lengthBetween": "Voer tekens in tussen {min} en {max}",
    "integer": "Dit veld moet een geheel getal zijn.",
    "decimal": "Dit veld moet een decimaal getal zijn.",
    "validNumber": "Voer een geldig nummer in.",
    "min": "Voer een waarde in groter dan of gelijk aan {min}.",
    "max": "Voer een waarde in kleiner dan of gelijk aan {max}.",
    "lengthMin": "Voer minimaal {length} tekens in",
    "between": "Voer een nummer in tussen {min} en {max}.",
    "minTwoFields": "Minstens één waarde moet {min} of groter zijn.",
    "sase": "Chassisnummer is niet geldig",
    "startDateInline": "Startdatum mag niet na {target} liggen",
    "endDateInline": "Einddatum mag niet voor {target} liggen"
  },
  "activeOptions": {
    "Hepsi": "Alle",
    "Aktif": "Actief",
    "Pasif": "Passief"
  },
  "projeFaturaTipList": {
    "Kısmı": "Gedeeltelijk",
    "Tam": "Volledig"
  },
  "musteriTip": {
    "Alış-Satış": "Inkoop-Verkoop",
    "Alış": "Inkoop",
    "Satış": "Verkoop"
  },
  "paraTur": {
    "TL": "TL",
    "Euro": "Euro",
    "Dolar": "Dollar"
  },
  "satisDurum": {
    "Onayli": "Goedgekeurd",
    "Bekliyor": "In afwachting",
    "Iptal": "Geannuleerd",
    "Cayma": "Herroeping"
  },
  "satisTip": {
    "Yok": "Geen",
    "case2": "case2",
    "case3": "case3"
  },
  "odemeSekli": {
    "1 Aylık": "1 Maand",
    "3 Aylık": "3 Maanden",
    "6 Aylık": "6 Maanden",
    "12 Aylık": "12 Maanden"
  },
  "projeHourTypesList": {
    "Seçiniz": "Selecteer",
    "General hours": "Algemene uren",
    "AI-IS AI Models": "AI-IS AI Modellen",
    "AI-IS MM support": "AI-IS MM Ondersteuning",
    "AI-IS Commercial": "AI-IS Commerciël",
    "AI-IS Non-commercial": "AI-IS Niet-commercieel",
    "Bee4GIS Commercial": "Bee4GIS Commercieel",
    "Bee4GIS Non-commercial": "Bee4GIS Niet-commercieel"
  },
  "projeAltStatusList": {
    "Bekliyor": "In afwachting",
    "İşlemde": "Bezig",
    "Bitti": "Voltooid"
  },
  "projeAltStatusAdminList": {
    "Bekliyor": "In afwachting",
    "İşlemde": "Bezig",
    "Bitti": "Voltooid",
    "Gönderildi": "Verzonden",
    "Onay": "Goedgekeurd",
    "Kapalı": "Gesloten"
  },
  "projeAltUcretTurList": {
    "Seçiniz": "Selecteer",
    "KM Fiyat": "KM-prijs",
    "Saat Fiyat": "Uurtarief",
    "Sabit Fiyat": "Vaste prijs",
    "Adet Fiyat": "Eenheidsprijs"
  },
  "medenidurumListe": {
    "Bilinmiyor": "Onbekend",
    "Bekar": "Vrijgezel",
    "Evli": "Getrouwd",
    "Boşanmış": "Gescheiden",
    "Dul": "Weduwe/Weduwnaar"
  },
  "ogrenimListe": {
    "Bilinmiyor": "Onbekend",
    "İlköğretim": "Lager onderwijs",
    "Ortaöğretim": "Voortgezet onderwijs",
    "Lise": "Middelbare school",
    "ÖnLisans": "Associate degree",
    "Lisans": "Bachelor",
    "Yüksek Lisans": "Master",
    "Doktora": "Doctoraat"
  },
  "kangrubuListe": {
    "Bilinmiyor": "Onbekend",
    "A+": "A+",
    "A-": "A-",
    "B+": "B+",
    "B-": "B-",
    "AB+": "AB+",
    "AB-": "AB-",
    "0+": "0+",
    "0-": "0-"
  },
  "cinsiyetListe": {
    "Bilinmiyor": "Onbekend",
    "Erkek": "Man",
    "Kadın": "Vrouw"
  },
  "egitimTurList": {
    "Diploma": "Diploma",
    "Sertifika": "Certificaat",
    "Belge": "Document",
    "Öğrenci": "Student"
  },
  "izinTurList": {
    "Yıllık ücretli izin": "Jaarlijks betaald verlof",
    "Ücretsiz izin": "Onbetaald verlof",
    "Mazeret izni": "Verlof met rechtvaardiging",
    "Diğer izinler": "Andere verloven",
    "Rapor": "Rapport"
  },
  "izinTurGetList": {
    "Yıllık ücretli girişi": "Jaarlijks betaalde toegang",
    "Yıllık ücretli izin": "Jaarlijks betaald verlof",
    "Ücretsiz izin": "Onbetaald verlof",
    "Mazeret izni": "Verlof met rechtvaardiging",
    "Diğer izinler": "Andere verloven",
    "Rapor": "Rapport"
  },
  "envanterStatusList": {
    "Yeni": "Nieuw",
    "Aktif": "Actief",
    "Zimmet": "Toegewezen bezit",
    "Tamirde": "In reparatie",
    "Depoda": "In opslag",
    "Demirbaş": "Inventaris",
    "Kayıp": "Verloren",
    "Pasif": "Passief",
    "Satıldı": "Verkocht",
    "Hurda": "Schroot",
    "Diğer": "Andere"
  },
  "komisyon_tur_liste": {
    "Komisyonsuz": "Geen Commissie",
    "Ape Komisyon": "Ape Commissie",
    "Sm Ape Komisyon": "Sm Ape Commissie"
  },
  "yemekKartiTipi": {
    "Yok": "Geen",
    "Mobil": "Mobiel",
    "Fiziksel": "Fysiek"
  },
  "Acil Durum": "Noodcontact",
  "Ad": "Naam",
  "Ad Soyad": "Naam en Achternaam",
  "Ad daha önceden kayıt edilmiş.": "Naam is al geregistreerd.",
  "Adet": "Aantal",
  "Adres": "Adres",
  "Aktif Kayıt": "Actief Record",
  "Aktif/Pasif": "Actief/Passief",
  "Ana Sayfa": "Dashboard",
  "Anket Başarıyla Gönderildi": "Enquête succesvol verzonden.",
  "Anket Başlığı": "Titel van de enquête",
  "Anket Bilgileri": "Enquête-informatie",
  "Anket Cevapları": "Enquêterespons",
  "Anket Listesi": "Enquötelijst",
  "Anket Oluştur": "Enquête aanmaken",
  "Anket Public": "Publieke Enquête",
  "Anket Silindi": "Enquête succesvol verwijderd.",
  "Anket Sonuçları": "Enquêteresultaten",
  "Anket Soruları": "Enquêtevragen",
  "Anket Yönetimi": "Enquêtebeheer",
  "Anket cevaplarınız başarıyla kaydedilmiştir.": "Uw antwoorden zijn succesvol opgeslagen.",
  "Anket cevaplarınız kaydedildi. Teşekkürler!": "Uw antwoorden zijn opgeslagen. Bedankt!",
  "Anket silindi.": "Enquête verwijderd.",
  "Anketi Düzenle": "Enquête bewerken",
  "Anketi Gönder": "Enquête verzenden",
  "Anketi Sil": "Enquête verwijderen",
  "Anketi Tamamla ve Gönder": "Enquête voltooien en verzenden",
  "Anketi göndermek istediğinize emin misiniz?": "Weet u zeker dat u de enquête wilt verzenden?",
  "Anketi Çöz": "Enquête invullen",
  "Anketler": "Enquêtes",
  "Anketlerim": "Mijn Enquêtes",
  "Ara": "Zoeken",
  "Ara...": "Zoeken...",
  "Arama": "Zoeken",
  "Ayarları Güncelle": "Instellingen Bijwerken",
  "Aygul Yazılım": "Aygul Software",
  "Aygül Yazılım": "Aygul Software",
  "Az Bulutlu": "Licht Bewolkt",
  "Açık / Güneşli": "Helder / Zonnig",
  "Açık Uçlu": "Open Vraag",
  "Açık Uçlu (Metin)": "Open vraag (Tekst)",
  "Açıklama": "Beschrijving",
  "Açıklama Metni (Cevapsız)": "Beschrijvingstekst (Geen antwoord)",
  "Banka": "Bank",
  "Barkod": "Barcode",
  "Bas Saat": "Starttijd",
  "Baş Saat": "Begintijd",
  "Baş.Tarih": "Startdatum",
  "Başarılı!": "Succesvol!",
  "Başlangıç": "Start",
  "Başlangıç Saat": "Starttijd",
  "Başlangıç Tarih": "Startdatum",
  "Başlangıç Tarihi Bitiş Tarihinden sonra olamaz": "Startdatum mag niet na einddatum liggen",
  "Başlık": "Titel",
  "Belge Tür": "Documenttype",
  "Bildirim başarıyla gönderildi.": "Melding succesvol verzonden.",
  "Bilgi Notu": "Notitie",
  "Bilgiler": "Informatie",
  "Bilgiler Alınıyor": "Gegevens worden opgehaald",
  "Bilgiler Hatalı olabilir kontrol ediniz.": "Informatie kan onjuist zijn, controleer aub.",
  "Bilinmeyen Konum": "Onbekende Locatie",
  "Bit Saat": "Eindtijd",
  "Bit.Tarih": "Einddatum",
  "Bitiş": "Einde",
  "Bitiş Saat": "Eindtijd",
  "Bitiş Saat Başlangıçdan Küçük Olamaz": "Eindtijd kan niet kleiner zijn dan starttijd",
  "Bitiş Tarih": "Einddatum",
  "Bitiş Tarihi Başlangıç Tarihinden önce olamaz": "Einddatum mag niet voor startdatum liggen",
  "Bu alan zorunludur": "Dit veld is verplicht",
  "Bu ankete daha önce katılım sağladınız.": "U heeft al deelgenomen aan deze enquête.",
  "Bu cevabı silmek istediğinize emin misiniz?": "Weet u zeker dat u dit antwoord wilt verwijderen?",
  "Bu gereksinimlerin karşılandığından emin olun": "Zorg ervoor dat aan deze vereisten wordt voldaan",
  "Bu müşterinin bu kodla kayıtı var.": "Deze klant heeft al een record met deze code.",
  "Bu soruyu cevaplamanız gerekmektedir.": "U moet deze vraag beantwoorden.",
  "Bulunamadı, UTC gösteriliyor.": "Niet gevonden, UTC wordt getoond.",
  "Bölge bulunamadı": "Regio niet gevonden",
  "Bölüm": "Afdeling",
  "BİLİŞİM": "IT",
  "COMMENT": "REACTIE",
  "Cep": "Mobiel",
  "Cevabınız": "Uw antwoord",
  "Cevap": "Antwoord",
  "Cevap (Seçenek)": "Antwoord (Optie)",
  "Cevap Detayları": "Antwoorddetails",
  "Cevap Sayısı": "Aantal Antwoorden",
  "Cevap yok": "Geen antwoord",
  "Cevaplanmış anketler silinemez.": "Beantwoordde enquêtes kunnen niet worden verwijderd.",
  "Cevaplar": "Antwoorden",
  "Choose": "Kies",
  "Cinsiyet": "Geslacht",
  "Create an account": "Account aanmaken",
  "DEMİRBAŞ": "INVENTARIS",
  "Daha Önce Katıldınız": "Reeds deelgenomen",
  "Dakika": "Minuut",
  "Data Yenile": "Gegevens Vernieuwen",
  "Detay": "Detail",
  "Detayları Gör": "Details bekijken",
  "Doküman Kaydedildi": "Document succesvol opgeslagen.",
  "Doküman Yüklenemedi": "Fout bij het laden van document.",
  "Doküman İçeriği": "Documentinhoud",
  "Doğrulama Yöntemi": "Verificatiemethode",
  "Doğrulama kodu gönderilemedi. Lütfen tekrar deneyin.": "Verificatiecode kon niet worden verzonden. Probeer het opnieuw.",
  "Doğum Tarihi": "Geboortedatum",
  "Durum": "Status",
  "Düzeltme": "Correctie",
  "Düzenle": "Bewerken",
  "E-mail": "E-mail",
  "Ekle": "Toevoegen",
  "Eksik Bilgi var. Kontrol ediniz.": "Er ontbreekt informatie. Controleer dit alstublieft.",
  "Eksik Seçenek": "Ontbrekende optie",
  "Email": "E-mail",
  "Email Sistemi": "E-mailsysteem",
  "Email Şifresi": "E-mailwachtwoord",
  "Emin misiniz?": "Weet u het zeker?",
  "En Az 5 Dakika fark olmalı": "Er moet minimaal 5 minuten verschil zijn",
  "Enter your email and we'll send you instructions to reset your password": "Voer uw e-mailadres in en wij sturen u instructies om uw wachtwoord opnieuw in te stellen.",
  "Envanter Ad": "Inventarisnaam",
  "Etiketle": "Labelen",
  "Etiketler": "Labels",
  "Etkinlik": "Activiteit",
  "Evet": "Ja",
  "Evet, Sil": "Ja, Verwijder",
  "Evet, gönder!": "Ja, verstuur!",
  "Evlilik Tarihi": "Huwelijksdatum",
  "Excel İndir": "Excel downloaden",
  "Excel'e Aktar": "Exporteren naar Excel",
  "Eğitim": "Opleiding",
  "Fakülte": "Faculteit",
  "Filtrele": "Filter",
  "Firma": "Bedrijf",
  "Forgot Password?": "Wachtwoord vergeten?",
  "Fotoğraf": "Foto",
  "Fotoğraf İşlemleri": "Foto Bewerkingen",
  "Fırtına": "Storm",
  "GPS Yok": "Geen GPS",
  "Gece": "Nacht",
  "Geen gegevens gevonden": "Geen gegevens gevonden",
  "Genel": "Algemeen",
  "Genel Bilgi": "Algemene Informatie",
  "Genel Durum Aylık Rapor": "Algemene Status Maandrapport",
  "Geçersiz doğrulama kodu.": "Ongeldige verificatiecode.",
  "Giriş": "Ingang",
  "Gizle": "Verbergen",
  "Gönder": "Verzenden",
  "Gün": "Dag",
  "Günaydın ☀️": "Goedemorgen ☀️",
  "Güncelle": "Bijwerken",
  "Gündüz": "Dag",
  "Günün Tamamlanması": "Dag Voltooiing",
  "Günün İlerlemesi": "Dagvoortgang",
  "Hafif Kar": "Lichte Sneeuw",
  "Hafif Yağmur": "Lichte Regen",
  "Hafif Çiseleme": "Lichte Motregen",
  "Hafta": "Week",
  "Hava Açık": "Onbewolkt",
  "Hava Durumu": "Weer",
  "Hava durumu bilgisi alınamadı.": "Weerinformatie niet beschikbaar.",
  "Hava durumu servisine erişilemedi.": "Weerservice onbereikbaar.",
  "Hava durumu verisi alınamadı.": "Weergegevens konden niet worden opgehaald.",
  "Hayır": "Nee",
  "Henüz anket bulunmuyor.": "Nog geen enquêtes gevonden.",
  "Henüz cevap bulunmuyor.": "Nog geen antwoorden.",
  "Henüz cevap yok.": "Nog geen antwoorden.",
  "Her hakkı saklıdır": "Alle rechten voorbehouden",
  "Hissedilen": "Gevoelstemperatuur",
  "Home": "Startpagina",
  "Hour Types": "Urensoorten",
  "Hours Type": "Urentype",
  "Hoşgeldiniz {name}": "Welkom {name}",
  "IBAN": "IBAN",
  "Incoming Documents": "Inkomende Documenten",
  "KABLO": "KABEL",
  "KOLTUK": "STOEL",
  "KYS Paneli": "KMS Paneel",
  "Kalan Ücretli İzin Günü": "Resterende betaalde verlofdagen",
  "Kalan İzin": "Resterend verlof",
  "Kan Grubu": "Bloedgroep",
  "Kanban": "Kanban",
  "Kapat": "Sluiten",
  "Kar Yağışlı": "Sneeuwachtig",
  "Kategori Doküman Takip": "Categorie Document Opvolging",
  "Katılım Sayısı": "Aantal deelnemers",
  "Katılım detayları yüklenemedi.": "Fout bij laden van details.",
  "Katılım silindi.": "Deelname verwijderd.",
  "Katılımlar yüklenirken hata oluştu.": "Fout bij laden van reacties.",
  "Kaydet": "Opslaan",
  "Kayıt": "Registratie",
  "Kayıt Yok!": "Geen gegevens gevonden!",
  "Kimlik No": "Identiteitsnummer",
  "Kod": "Code",
  "Kod Proje": "Projectcode",
  "Kod daha önceden kayıt edilmiş.": "De code is al eerder geregistreerd.",
  "Konu": "Onderwerp",
  "Konum Aranıyor...": "Locatie Zoeken...",
  "Konum Bekleniyor...": "Wachten op locatie...",
  "Konum Bulunuyor...": "Locatie Vinden...",
  "Konum Hesaplanıyor...": "Locatie berekenen...",
  "Konum alınamadı.": "Locatie kon niet worden opgehaald.",
  "Konum bilgisi alınamadı": "Locatie-informatie niet gevonden",
  "Konum isteği zaman aşımına uğradı.": "Locatieverzoek time-out.",
  "Konumu Güncelle": "Locatie Bijwerken",
  "Konumu Yenile": "Locatie Vernieuwen",
  "Konumu Şimdi Kontrol Et": "Locatie Nu Controleren",
  "Kopyala": "Kopiëren",
  "Kullanici": "Gebruiker",
  "Kullanıcı": "Gebruiker",
  "Kullanıcı Mesai Süreleri": "Overuren Gebruiker",
  "Kurum/Okul": "Instelling/School",
  "Kırağı / Sis": "Rijp / Mist",
  "Laravel Log": "Laravel Log",
  "Liste Döküman Takip": "Lijst Document Opvolging",
  "Listeye Dön": "Terug naar lijst",
  "MASA": "TAFEL",
  "MONİTÖR": "MONITOR",
  "MOUSE": "MUIS",
  "MUTFAK": "KEUKEN",
  "Mail Sistemi": "Mailsysteem",
  "Medeni Durum": "Burgerlijke staat",
  "Mesai": "Overwerk",
  "Metin girilmedi": "Geen tekst ingevoerd",
  "Metre": "Meter",
  "Miktar": "Hoeveelheid",
  "Minimum 8 karakter uzunluğunda, büyük harf ve sembol !@#$%&*()": "Minimaal 8 tekens lang, hoofdletter en symbool !{'@'}#$%&*()",
  "Müşteri": "Klant",
  "NETWORK": "NETWORK",
  "NOTEBOOK": "NOTEBOOK",
  "Nem": "Vochtigheid",
  "No data available": "Geen gegevens beschikbaar",
  "Not": "Opmerking",
  "Oluştur": "Maken",
  "Oluşturulma": "Aangemaakt op",
  "Onay Tarih": "Goedkeuringsdatum",
  "Otomatik hesaplanır (veya 1'den başlar)": "Automatisch berekend (of start vanaf 1)",
  "Overall": "Overzicht",
  "Overall Rapor Aylık": "Algemeen Rapport Maandelijks",
  "PC": "PC",
  "PDF oluşturulurken hata": "Fout bij het maken van PDF.",
  "Paket": "Pakket",
  "ParaTür": "Valuta Type",
  "Parçalı Bulutlu": "Half Bewolkt",
  "Pasif Kayıt": "Passief Record",
  "Pasif/Süresi Dolmuş": "Passief/Verlopen",
  "Password": "Wachtwoord",
  "Performans": "Prestaties",
  "Personel": "Personeel",
  "Personel Profil2": "Personeelsprofiel 2",
  "Pertentage Opa Rapor": "Percentage OPA Rapport",
  "Pertentage Oparator Rapor -": "Percentage Operator Rapport -",
  "Pertentage Rapor": "Percentage Rapport",
  "Proje": "Project",
  "Proje Alt": "Subproject",
  "Proje Tanıtım": "Projectdefinities",
  "Proje-Paket": "Project-Pakket",
  "Projealt": "Subproject",
  "Puan": "Score",
  "Puan güncellendi.": "Score bijgewerkt.",
  "Rapor Overall -": "Rapport Overall -",
  "Rapor Proje -": "Projectrapport -",
  "Raporlar": "Rapporten",
  "Rüzgar": "Wind",
  "SANDALYE": "STOEL",
  "STAND": "STANDAARD",
  "Saat": "Uur",
  "Sabit Zaman": "Vaste Tijd",
  "Saniye": "Seconde",
  "ScheduleMonitor": "ScheduleMonitor",
  "Seçenek Ekle": "Optie toevoegen",
  "Seçenek metni": "Optietekst",
  "Seçenekler": "Opties",
  "Seçili Konum": "Geselecteerde Locatie",
  "Seçmeli sorularda en az 2 seçenek olmalıdır.": "Meerkeuzevragen moeten minstens 2 opties hebben.",
  "Shortcut": "Snelkoppeling",
  "Shortcut already exists": "Snelkoppeling bestaat al",
  "Sicil No": "Personeelsnummer",
  "Sil": "Verwijderen",
  "Silme Onayı": "Bevestig Verwijdering",
  "Sisli": "Mistig",
  "Son Hareket": "Laatste Beweging",
  "Son Kontrol": "Laatste Controle",
  "Son güncel": "Laatst Bijgewerkt",
  "Sonuçlar": "Resultaten",
  "Soru": "Vraag",
  "Soru Bazlı Analiz": "Analyse per vraag",
  "Soru Ekle": "Vraag toevoegen",
  "Soru Metni": "Vraagtekst",
  "Soru Sayısı": "Aantal vragen",
  "Soru Tipi": "Vraagtype",
  "Spam'e Taşı": "Verplaatsen naar Spam",
  "Status": "Status",
  "Süre": "Duur",
  "Sıra": "Volgorde",
  "TV": "TV",
  "Takip Kod": "Track & Trace Code",
  "Takvim": "Kalender",
  "Takvim Doğum Günü Göster": "Verjaardag in kalender tonen",
  "Tamamlanma Tarihi": "Voltooiingsdatum",
  "Tanıtım": "Introductie",
  "Tarayıcı desteği yok.": "Browser niet ondersteund.",
  "Tarih": "Datum",
  "Tarih Aralığı": "Periode",
  "Taslak": "Concept",
  "Taşı": "Verplaatsen",
  "Tek Seçmeli": "Enkele Keuze",
  "Tek Seçmeli (Radyo)": "Meerkeuze (Radio)",
  "Telefon": "Telefoon",
  "Temizle": "Opruimen",
  "Teslim Tarih": "Leveringsdatum",
  "Teşekkürler!": "Bedankt!",
  "Tip": "Type",
  "Toplam Cevap": "Totaal antwoorden",
  "Toplam Katılımcı": "Totaal deelnemers",
  "Toplam Puan": "Totaal Score",
  "Toplam Puan:": "Totaal Score:",
  "Tümü": "Alle",
  "Tümünü Excel İndir": "Download Alle Excel",
  "Tünaydın 👋": "Goedemiddag 👋",
  "Tür": "Type",
  "USB ETH": "USB ETH",
  "Undefined variable $tarih": "Ongedefinieerde variabele $tarih",
  "Uygulama çevrimdışı çalışmaya hazır.": "App is klaar voor offline gebruik.",
  "Uygulama İndir": "Download App",
  "Varsayılan": "Standaard",
  "Veri bulunamadı": "Geen gegevens gevonden",
  "Veri yükleniyor...": "Gegevens laden...",
  "Veriliş Tarihi": "Uitgiftedatum",
  "WEBCAM": "WEBCAM",
  "Webcam": "Webcam",
  "Word Dosyası Yükle": "Word-bestand Uploaden",
  "YAZICI": "PRINTER",
  "Yakınlık": "Nabijheid",
  "Yayında": "Gepubliceerd",
  "Yağmurlu": "Regenachtig",
  "Yeni Anket Oluştur": "Nieuwe enquête aanmaken",
  "Yeni Güncelleme Mevcut!": "Nieuwe update beschikbaar!",
  "Yeni özellikleri ve düzeltmeleri görmek için sayfayı yenileyin.": "Vernieuw de pagina om nieuwe functies en updates te zien.",
  "Yeni Şifre": "Nieuw wachtwoord",
  "Yerel": "Lokaal",
  "Yerel Saat": "Lokale Tijd",
  "Yerel Saat Dilimi": "Lokale Tijdzone",
  "Yetkiniz bulunmuyor. Hata olduğunu düşünüyorsanız Admin'e Bilgi verin.": "U bent niet bevoegd. Als u denkt dat dit een fout is, neem dan contact op met de beheerder.",
  "Your new password must be different from previously used passwords": "Uw nieuwe wachtwoord moet verschillend zijn van eerdere wachtwoorden.",
  "Yoğun Kar": "Zware Sneeuw",
  "Yoğun Çiseleme": "Zware Motregen",
  "Yönetim": "Beheer",
  "Yönetim Anket": "Enquêtebeheer",
  "Yükleniyor...": "Laden...",
  "Yüzde": "Percentage",
  "Yıl": "Jaar",
  "Zaman Dilimi": "Tijdzone",
  "Zorunlu Cevap": "Verplicht antwoord",
  "için gün bitimi": "einde dag voor",
  "title alanı gereklidir.": "Titelveld is verplicht.",
  "welcome": "Welkom {title}! 👋🏻",
  "Çiseleme": "Motregen",
  "Çocuk Sayısı": "Aantal kinderen",
  "Çok Seçmeli": "Meerkeuze",
  "Çok Seçmeli (Onay Kutusu)": "Meerdere keuzes (Checkbox)",
  "Çoğunlukla Açık": "Meestal Helder",
  "Özet": "Overzicht",
  "Öğrenim": "Onderwijsniveau",
  "Ünvan": "Titel",
  "İki Aşamalı Doğrulama (2FA)": "Twee-factor-authenticatie (2FA)",
  "İlk Hareket": "Eerste Beweging",
  "İndir": "Downloaden",
  "İnsan Kaynakları": "Human Resources",
  "İptal": "Annuleren",
  "İyi Akşamlar 🌇": "Goedenavond 🌇",
  "İyi Geceler 🌙": "Goedenacht 🌙",
  "İzin": "Verlof",
  "İzin Hakediş Tarihi": "Vergunningsdatum verlof",
  "İzin Tür": "Verloftype",
  "İzin Türü": "Type verlof",
  "İzin Verilmedi": "Toestemming Geweigerd",
  "İzinli Gün": "Verlofdag",
  "İş Başlangıç Tarihi": "Indiensttredingsdatum",
  "İş Yeri": "Werkplek",
  "İşlem": "Actie",
  "İşlemler": "Acties",
  "Şehir Bulunamadı": "Stad Niet Gevonden",
  "Şehir veya Ülke Seçiniz": "Kies Stad of Land",
  "Şiddetli Yağmur": "Zware Regen",
  "Şifre": "Wachtwoord",
  "Şifre Değiştir": "Wachtwoord wijzigen",
  "Şimdi Yenile": "Nu Vernieuwen",
  "Şube": "Filiale",
  "Zorunlu": "Verplicht",
  "Yeni Kayıt": "Nieuw Record",
  "İş Giriş Çıkış Tanımları": "Werk In Uit Definities",
  "Kayıt bulunamadı.": "Record niet gevonden.",
  "EBYS": "EDMS",
  "Inkomende Documenten": "Inkomende Documenten",
  "Onay Bekliyor": "Wapacht op Goedkeuring",
  "İmzalandı": "Ondertekend",
  "Sevk Edildi": "Verzonden",
  "Tamamlandı": "Voltooid",
  "Hata oluştu": "Er is een fout opgetreden",
  "Kullanıcı Seçiniz": "Selecteer Gebruiker",
  "konu alanı gereklidir.": "Onderwerp veld is verplicht.",
  "Bildirimler": "Meldingen",
  "Tümünü Okunmadı Olarak İşaretle": "Markeer alles als ongelezen",
  "Tümünü Okundu Olarak İşaretle": "Markeer alles als gelezen",
  "Bildirim Bulunamadı!": "Geen meldingen gevonden!",
  "Tüm Bildirimleri Gör": "Bekijk alle meldingen",
  "Tüm Bildirimler": "Alle meldingen",
  "Hiç bildiriminiz yok.": "Je hebt geen meldingen.",
  "Hafif Sağanak Yağış": "Lichte Regenbui",
  "Sağanak Yağış": "Regenbui",
  "Şiddetli Sağanak Yağış": "Zware Regenbui",
  "Hafif Dondurucu Çiseleme": "Lichte Ijsregen",
  "Yoğun Dondurucu Çiseleme": "Dichte Ijsregen",
  "Hafif Dondurucu Yağmur": "Lichte IJzel",
  "Yoğun Dondurucu Yağmur": "Zware IJzel",
  "Yoğun Kar Yağışlı": "Zware Sneeuwval",
  "Kar Taneleri": "Sneeuwkorrels",
  "Hafif Kar Sağanağı": "Lichte Sneeuwbui",
  "Yoğun Kar Sağanağı": "Zware Sneeuwbui",
  "Dolu Karışık Fırtına": "Onweer met Hagel",
  "Şiddetli Dolu Karışık Fırtına": "Onweer met Zware Hagel",
  "Bu tarihe mesai girilemez.": "Overwerken kan niet worden ingevoerd voor deze datum.",
  "Kategoriler": "Categorieën",
  "Galeri": "Galerij",
  "Belge Bilgi Bankası": "Document Kennisbank",
  "Organizasyon": "Organisatie",
  "Organizasyon Başlıkları": "Organisatietitels",
  "Personel Dosyaları": "Personeelsdossiers",
  "Mesai Rapor": "Overwerk Rapport",
  "Overall Rapor": "Algemeen Rapport",
  "Kullanıcı Yetki Rapor": "Gebruikersautorisatie Rapport",
  "Fatura AI": "Factuur AI",
  "Destek Talepleri": "Ondersteuningsverzoeken",
  "Telefon Rehberi": "Telefoonboek",
  "Bildirim Gönder": "Melding Verzenden",
  "Pertentage Oparator Rapor": "Operator Percentage Report",
  "auth": {
    "Farklı bir hesapla giriş yap": "Inloggen met een ander account"
  }
}
